import {
    useCallSheetState,
} from "../../../../hooks/callSheet";
import DateTimePicker from '../../../components/common/datePicker';
import WeatherSection from '../../../components/weather-section';
import TimeTool from '../../../components/time-tool';
import { formatTime } from "../../../../helper/converters";

import './index.scss'

const InfoCard = (props: any) => {

    const {
        zipcode,
        dayEnd,
        dayStar,
        weather,
        infoCard,
    } = props;

    const callSheetState = useCallSheetState();
    const dateCallsheet = callSheetState.date.get();

    return (
        <div className="card">
            <div className="card-information">
                <div className="card-information-datePicker">
                    <DateTimePicker
                        date={dateCallsheet}
                    />
                </div>
                <div className="card-information-dateRange">
                    <span>Day</span>
                    <input
                        type="text"
                        maxLength={2}
                        value={dayStar}
                        disabled
                    />
                    <span>of</span>
                    <input
                        type="text"
                        value={dayEnd}
                        maxLength={2}
                        disabled
                    />
                </div>
            </div>
            <hr className="divide-line" />
            <WeatherSection
                weather={weather}
                zipcode={zipcode}
            />
            <hr className="divide-line" />
            <div className="card-information-schedule">
                <div className="row">
                    <div className="card-information-schedule event">
                        <span>Breakfast</span>
                    </div>
                    <div className="card-information-schedule time">
                        <TimeTool
                            disabled={true}
                            size="small"
                            time={
                                infoCard["breakfast"] && infoCard["breakfast"] !== ""
                                    ? formatTime(infoCard["breakfast"])
                                    : ""
                            }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="card-information-schedule event">
                        <span>Crew Call</span>
                    </div>
                    <div className="card-information-schedule time">
                        <TimeTool
                            disabled={true}
                            size="small"
                            time={
                                infoCard["crew"] && infoCard["crew"] !== ""
                                    ? formatTime(infoCard["crew"])
                                    : ""
                            }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="card-information-schedule event">
                        <span>Shooting Call</span>
                    </div>
                    <div className="card-information-schedule time">
                        <TimeTool
                            disabled={true}
                            size="small"
                            time={
                                infoCard["shooting"] && infoCard["shooting"] !== ""
                                    ? formatTime(infoCard["shooting"])
                                    : ""
                            }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="card-information-schedule event">
                        <span>Lunch</span>
                    </div>
                    <div className="card-information-schedule time">
                        <TimeTool
                            disabled={true}
                            size="small"
                            time={
                                infoCard["lunch"] && infoCard["lunch"] !== ""
                                    ? formatTime(infoCard["lunch"])
                                    : ""
                            }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="card-information-schedule event">
                        <span>2nd Meal</span>
                    </div>
                    <div className="card-information-schedule time">
                        <TimeTool
                            disabled={true}
                            size="small"
                            time={
                                infoCard["meal"] && infoCard["meal"] !== ""
                                    ? formatTime(infoCard["meal"])
                                    : ""
                            }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="card-information-schedule event">
                        <span>Est. Wrap</span>
                    </div>
                    <div className="card-information-schedule time">
                        <TimeTool
                            disabled={true}
                            size="small"
                            time={
                                infoCard["wrap"] && infoCard["wrap"] !== ""
                                    ? formatTime(infoCard["wrap"])
                                    : ""
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InfoCard